import React, { useContext, useEffect, useState } from 'react'
import Icon from 'react-icons-kit'
import { edit2 } from 'react-icons-kit/feather'
import { useForm } from 'react-hook-form'
import User from "../../../utils/Requests/User"
import { optionContext } from '../../../utils/Context/optionContext'
import SingleSelect from '../../form/SingleSelect'
// import './style.scss'
import { toast } from 'react-toastify'
//import 'react-toastify/dist/ReactToastify.css'
////toast.configure({ autoClose: 2000 })

const EducationCareer = ({ user, email, handleRefetch }) => {
    const { options, handleOptionToData } = useContext(optionContext)
    const [EducationEdit, setEducationEdit] = useState({ show: false, loading: false })
    const { handleSubmit, register } = useForm()
    const [header] = useState({ headers: { Authorization: "Bearer " + localStorage.getItem('token') } })
    const { qualification, institute, workingWith, professionArea } = user.educationAndProfession
    const { startFrom, endTo } = user.annualIncome

    const [newQualification, setQualification] = useState({
        value: null,
        options: []
    })

    const [newWorkingWith, setWorkingWith] = useState({
        value: null,
        options: []
    })
    const [newProfessionArea, setProfessionArea] = useState({
        value: null,
        options: []
    })
    const [annualIncome, setAnnualIncome] = useState({
        value: null,
        options: []
    })
    useEffect(() => {
        setQualification({ ...newQualification, options: handleOptionToData("Qualification") })
        setWorkingWith({ ...newWorkingWith, options: handleOptionToData("Working with") })
        setProfessionArea({ ...newProfessionArea, options: handleOptionToData("Profession area") })
        setAnnualIncome({ ...annualIncome, options: handleOptionToData("Income") })
    }, [options])

    const onSubmit = async (data) => {
        let obj = {
            qualification: newQualification.value,
            institute: data.institute ? data.institute : null,
            workingWith: newWorkingWith.value,
            professionArea: newProfessionArea.value,
            annualIncome: annualIncome.value
        }
        setEducationEdit({ ...EducationEdit, loading: true })
        const response = await User.UpdateEducationAndCareer(email, obj, header)
        if (response.status) {
            toast.success('Successfully saved your Bio')
        }
        setEducationEdit({ show: false, loading: false })
        handleRefetch()
    }

    return (
        <div className="detailInformations" >
            <div className="card shadow mb-4" >
                <div className="card-header px-4 pt-3 pb-0">
                    <div className="d-flex justify-content-between">
                        <div><h5 className="mb-0"> Education & Career </h5></div>
                        <div className="ml-auto">
                            <button className="btn rounded-circle shadow"
                                onClick={() => setEducationEdit({ ...EducationEdit, show: !EducationEdit.show })}
                            >
                                <Icon icon={edit2} size={20} />
                            </button>
                        </div>
                    </div>
                </div>
                <div className="card-body p-4">
                    {
                        EducationEdit.show ? <form onSubmit={handleSubmit(onSubmit)}>

                            <div className="form-group mb-4">
                                <p>Qualification</p>

                                <SingleSelect
                                    options={newQualification.options}
                                    data={qualification}
                                    value={(data) => setQualification({ ...newQualification, value: data })}
                                />
                            </div>
                            <div className="form-group mb-4">
                                <p>College(s) Attended</p>
                                <input
                                    type="text"
                                    className="form-control shadow-none"
                                    placeholder="your educational institite name"
                                    defaultValue={institute || ''}
                                    name='institute'
                                    {...register('institute')}
                                />
                            </div>
                            <div className="form-group mb-4">
                                <p>Working with</p>

                                <SingleSelect
                                    options={newWorkingWith.options}
                                    data={workingWith}
                                    value={(data) => setWorkingWith({ ...newWorkingWith, value: data })}
                                />
                            </div>
                            <div className="form-group mb-4">
                                <p>Profession area</p>

                                <SingleSelect
                                    options={newProfessionArea.options}
                                    data={professionArea}
                                    value={(data) => setProfessionArea({ ...newProfessionArea, value: data })}
                                />
                            </div>
                            <div className="form-group mb-4">
                                <p>Annual income in $USD</p>

                                <SingleSelect
                                    options={annualIncome.options}
                                    data={`${startFrom}-${endTo}`}
                                    value={(data) => setAnnualIncome({ ...annualIncome, value: data })}
                                />
                            </div>



                            <div className="text-end pt-3">
                                <button
                                    type="submit"
                                    className="btn shadow-none save-btn"
                                    disabled={EducationEdit.loading}
                                >
                                    {EducationEdit.loading ? 'Saving...' : 'Save'}
                                </button>
                            </div>
                        </form>
                            :
                            <div className="row" >
                                <div className=" col-12 col-md-6 ">
                                    <table >
                                        <thead>
                                            <tr>
                                                <th>Highest Qualification</th>
                                                <td className="pl-5">:</td>
                                                <td>{qualification ? qualification : "N/A"}</td>
                                            </tr>
                                            <tr>
                                                <th>College(s) Attended</th>
                                                <td className="pl-5">:</td>
                                                <td>{institute ? institute : "N/A"}</td>
                                            </tr>
                                            <tr>
                                                <th>Annual Income</th>
                                                <td className="pl-5">:</td>
                                                <td>{startFrom ? startFrom : "N/A"} - {endTo ? endTo : "N/A"}</td>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                                <div className="col-12 col-md-6 ">
                                    <table >
                                        <thead>
                                            <tr>
                                                <th>Working with</th>
                                                <td className="pl-5">:</td>
                                                <td>{workingWith ? workingWith : "N/A"}</td>
                                            </tr>
                                            <tr>
                                                <th>Profession Area</th>
                                                <td className="pl-md-5">:</td>
                                                <td>{professionArea ? professionArea : "N/A"}</td>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                            </div>
                    }
                </div>
            </div>
        </div>
    );
};

export default EducationCareer;